import React from 'react';

import {useAddArticle, useArticles, useCategories} from 'app/kbs/api';
import {gt} from 'app/utils/i18n';

import {KBItemList} from './KBItemList';

import {BaseDocumentContentType, KBCategorySerializedType} from 'sweet-types';

type CategorySelectionListProps = {
  refreshPosition: () => void;
  setParentFolder: (parentFolder: KBCategorySerializedType) => void;
  onSuccess: () => Promise<any>;
  contentType: BaseDocumentContentType;
  objectId: number | string;
  search: string;
  kb_id?: number;
  parent_category_id: string | number;
};
export const CategorySelectionList = ({
  refreshPosition,
  setParentFolder,
  onSuccess,
  contentType,
  objectId,
  search,
  kb_id,
  parent_category_id,
}: CategorySelectionListProps) => {
  const {data: kbData} = useCategories({
    parent_category_id: search
      ? undefined
      : kb_id != null
      ? parent_category_id
      : undefined,
    search,
    kb_id,
  });
  const {data: articleData} = useArticles({
    document_object_id: objectId,
    document_content_type: contentType,
  });
  const attachedCategories =
    articleData?.results == null
      ? []
      : articleData?.results.map((c) => c.category.url);

  const [addArticle] = useAddArticle();

  function actionsGetter(
    document: KBCategorySerializedType,
    afterActions: () => Promise<any>
  ) {
    const articleCheck =
      document.content_type === 'category' &&
      !attachedCategories.includes(document.url);
    return [
      {
        text: gt('Add to this category'),
        key: 'add-to-knowledge-base',
        icon: 'fas fa-plus',
        condition: () => articleCheck,
        callback: () =>
          document.content_type === 'category'
            ? addArticle({
                category_url: document.url,
                document_object_id: objectId,
                document_content_type: contentType,
                knowledgebase_url: document.knowledgebase.url,
              })
                .unwrap()
                .then(onSuccess)
                .then(afterActions)
            : Promise.resolve(true),
      },
    ];
  }

  return (
    <KBItemList
      kbList={kbData?.results}
      itemName={'category'}
      refreshPosition={refreshPosition}
      getItemCaption={(item: KBCategorySerializedType) => {
        if (search) {
          return item.knowledgebase.name;
        }
      }}
      setParentFolder={setParentFolder}
      actionsGetter={actionsGetter}
    />
  );
};
